import { Component, Input } from '@angular/core'
import { IonicModule } from '@ionic/angular'

@Component({
  selector: 'app-extended-fab',
  standalone: true,
  imports: [IonicModule],
  templateUrl: './extended-fab.component.html',
  styleUrls: ['./extended-fab.component.scss'],
})
export class ExtendedFabComponent {
  @Input() ioniconName: any
  @Input() text: string

  constructor() {}
}
